var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldenStar = function SvgGoldenStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC22F",
    d: "m12 0 4.215 6.186 7.152 2.12-4.547 5.944.205 7.496L12 19.233l-7.025 2.513.205-7.496L.633 8.306l7.152-2.12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD97D",
    d: "M12 12.01.633 8.305l7.152-2.12zM12 0l4.215 6.186L12 12.009z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6A705",
    d: "m12 12.01-6.82 2.24L.633 8.306zM12 12.01l11.367-3.704-4.547 5.944zM12 12.01l7.025 9.736L12 19.233l-7.025 2.513z"
  })));
};
export { SvgGoldenStar as ReactComponent };